// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "3c737661501dfc6d7734e192a8b67582" + ".css";
};